<template>
  <tr>
    <td title="Klant">
      <BadgeComponent v-if="hasCustomer" :customer="mortgage.customer.data"/>
    </td>
    <td>
      <span v-if="getProperty !== null">
        {{ getProperty.street }} {{ getProperty.number }}{{ getProperty.number_addition }}<br>
        {{ getProperty.postal_code }} {{ getProperty.city }}
      </span>
      <span v-else>-</span>
    </td>
    <td title="Contactgegevens">
      <template v-if="hasCustomer">
        <span v-if="getEmail">
          <i class="mdi mdi-at" title="E-mail"></i>
          {{ getEmail }}
          <br>
        </span>
        <span v-if="getPhone">
          <i class="mdi mdi-phone" title="Telefoon"></i>
          <a :href="'tel:' + getPhone">{{ getPhone }}</a>
          <br>
        </span>
        <span v-if="getMobile">
          <i class="mdi mdi-cellphone" title="Mobiel"></i>
          <a :href="'tel:' + getMobile">{{ getMobile }}</a>
        </span>
      </template>
    </td>
    <td>
      <span v-if="getCollateralAddress !== null">
        {{ getCollateralAddress.street }} {{ getCollateralAddress.number }}{{ getCollateralAddress.number_addition }}<br>
        {{ getCollateralAddress.postal_code }} {{ getCollateralAddress.city }}
      </span>
      <span v-else>-</span>
    </td>
    <td>{{ mortgage.passeerdatum | toDate }}</td>
    <td>{{ mortgage.marktwaarde | toCurrency(0) }}</td>
    <td>{{ mortgage.agency_name }}</td>
    <td>{{ mortgage.company_label_description }}</td>
    <!--    TODO: make hypotheeknummer link to mortgage.show -->
    <!--      <a href="{{ route('mortgage.show', [$mortgage->customer_id, $mortgage->id]) }}">-->
    <!--        {{ strlen($mortgage->hypotheeknummer) == 0 ? 'Leeg hypotheeknummer' : $mortgage->hypotheeknummer }}-->
    <!--      </a>-->

    <td>{{ mortgage.hypotheeknummer }}</td>
    <td>{{ mortgage.hypotheciareInschrijving | toCurrency(0) }}</td>
    <td>{{ mortgage.principal_sum | toCurrency(0) }}</td>
    <td>{{ mortgage.remaining_principal_sum | toCurrency(0) }}</td>
    <td>{{ mortgage.remaining_interest_only_sum | toCurrency(0) }}</td>
    <td>
      <show-product-label-component v-for="label in productLabels" :key="label.id"
                                    :product-label="label"></show-product-label-component>
    </td>
  </tr>
</template>

<script>
import ShowProductLabelComponent from '~/modules/product_label/components/ShowProductLabelComponent';
import BadgeComponent from "~/modules/customer/components/BadgeComponent";

export default {
  name: "SelectionMortgageRowComponent",
  components: {
    ShowProductLabelComponent,
    BadgeComponent
  },
  props: {
    mortgage: {
      type: Object,
      required: true,
    }
  },
  methods: {},
  computed: {
    hasCustomer() {
      return (this.mortgage.customer !== null && typeof this.mortgage.customer !== 'undefined');
    },
    hasCustomerData() {
      return this.hasCustomer && typeof this.mortgage.customer.data !== 'undefined' && this.mortgage.customer.data !== null;
    },
    hasHypotheeknummer() {
      return (this.mortgage.hypotheeknummer !== null && typeof this.mortgage.hypotheeknummer !== 'undefined');
    },
    getProperty() {
      if (!this.hasCustomer) return null;

      const property = this.mortgage.customer.data.addresses.data[0];

      if (property !== null && typeof property !== 'undefined' && Object.keys(property).length !== 0) {
        return {
          street: property.street_name,
          number: property.house_number,
          number_addition: property.house_number_addition ? property.house_number_addition : '',
          postal_code: property.postcode.toUpperCase(),
          city: property.city ? property.city.charAt(0).toUpperCase() + property.city.slice(1) : '',
        };
      }

      return null;
    },
    getCollateralAddress() {
      if (!this.hasCustomer) return null;

      if (this.mortgage.collateral_postcode !== null && typeof this.mortgage.collateral_postcode !== 'undefined') {
        return {
          street: this.mortgage.collateral_address,
          number: this.mortgage.collateral_housenumber,
          number_addition: this.mortgage.collateral_housenumber_addition ? this.mortgage.collateral_housenumber_addition : '',
          postal_code: this.mortgage.collateral_postcode.toUpperCase(),
          city: this.mortgage.collateral_city ? this.mortgage.collateral_city.charAt(0).toUpperCase() + this.mortgage.collateral_city.slice(1) : '',
        };
      }

      return null;
    },
    getEmail() {
      if (this.hasCustomerData) {
        return this.mortgage.customer.data.email_address;
      }
    },
    getPhone() {
      if (this.hasCustomerData) {
        return this.mortgage.customer.data.phone;
      }
    },
    getMobile() {
      if (this.hasCustomerData) {
        return this.mortgage.customer.data.mobile;
      }
    },
    productLabels() {
      if (this.mortgage.product_labels !== null && typeof this.mortgage.product_labels !== 'undefined') {
        return this.mortgage.product_labels.data;
      }
      return [];
    }
  }
}
</script>